var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import C from "classnames";
export const CardFooter = (_a) => {
    var { muted = true } = _a, props = __rest(_a, ["muted"]);
    return (React.createElement("div", { className: C("card-footer", muted && "text-muted", props.className), "data-testid": props.testId }, props.children));
};
//# sourceMappingURL=CardFooter.js.map